import { Box, createStyles, Popover } from '@mantine/core';
import { type CustomPropertyOut } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { useCallback, useState } from 'react';
import type { ISecodaEntity } from '../../api';
import { CustomPropertyRendererV2 } from '../CustomPropertyRenderV2';
import { type PropertySelectorProps } from './PropertySelector';

export interface CustomPropertiesPropertySelectorProps
	extends Pick<PropertySelectorProps, 'onChange'> {
	entity: ISecodaEntity;
	customProperty: CustomPropertyOut;
	readOnly?: boolean;
}

const useStyles = createStyles((theme) => ({
	dropdown: {
		padding: theme.spacing.xs,
	},
}));

export function CustomPropertiesPropertySelector({
	entity,
	customProperty,
	readOnly = false,
}: CustomPropertiesPropertySelectorProps) {
	const [isHovered, setIsHovered] = useState<boolean>(false);
	const { classes } = useStyles();

	const handleMouseEnter = useCallback(() => {
		setIsHovered(true);
	}, []);

	const handleMouseLeave = useCallback(() => {
		setIsHovered(false);
	}, []);

	return (
		<Popover
			withinPortal={true}
			opened={isHovered}
			position="bottom-start"
			classNames={classes}
		>
			<Popover.Target>
				<Box
					pl="xs"
					pr="xs"
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
				>
					<CustomPropertyRendererV2
						customProperty={customProperty}
						entity={entity}
						hideOnEmpty={false}
						readOnly={readOnly}
						disableHover={true}
					/>
				</Box>
			</Popover.Target>
			<Popover.Dropdown>
				<Text size="sm">{customProperty.name}</Text>
			</Popover.Dropdown>
		</Popover>
	);
}
